import { Axios } from "./request";

export const petPublish = data => {
  return Axios({
    url: "/api/web/publish",
    method: "post",
    data
  });
};

export const petPublishCount = data => {
  return Axios({
    url: "/api/publish/count/send",
    method: "GET",
    data
  });
};

export const getConfig = type => {
  return Axios({
    url: `/api/config/${type}`,
    method: "GET"
  });
};

export const getPublishDetail = itemId => {
  return Axios({
    url: `/api/web/publish/detail/${itemId}`,
    method: "GET"
  });
};

export const addReadCount = data => {
  return Axios({
    url: "/api/publish/detail/add",
    method: "POST",
    data
  });
};
